import { render } from "./PrivacyPopup.vue?vue&type=template&id=cb9fbca4&scoped=true"
import script from "./PrivacyPopup.vue?vue&type=script&lang=js"
export * from "./PrivacyPopup.vue?vue&type=script&lang=js"

import "./PrivacyPopup.vue?vue&type=style&index=0&id=cb9fbca4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9fbca4"]])

export default __exports__